import React, { useState } from 'react'
import Portfolio from './../components/Portfolio'
import Header from './../components/Header'
import Footer from './../components/Footer'
import Testimonials from './../components/Testimonials'
import { useSelector } from 'react-redux'
import CategoryList from './Category/CategoryList'
import { DilContext } from './ContextDil'

const Home = ({ resto, id, resim1, resim2, resim3, resim4, resim5, resim6, resim7 }) => {
  const productsData = useSelector(state => state.productsSlice.data);
  const categorydata = useSelector(state => state.categorySlice.data);
  const [categoryorder, setcategoryorder] = useState(0);
  const [serach, setSearch] = useState([]);
  const [lang, setLang] = useState('tr');

  // const [item, setItem] = useState([]);

  // const menuItems = [...new Set(productsData.map((Val) => Val.category))];

  const filterItem = () => {

    return productsData.filter((element) => element.CATEGORY === categorydata[categoryorder].CATEGORY)

  };
  const handleSearch = (event) => {
    if (event.target.value.length > 0) {
      const datax = productsData.filter(element => {
        return element.URUN_ADI.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1;
      });


      setSearch(datax);

    }

    else {
      setSearch([]);
    }
  };

  const setProducts = (order) => {
    if (productsData.length > 0) {

      setcategoryorder(order);
      setSearch([]);
    }
  };

  const cdata = {
    lang,
    setLang
  }

  return (
    <DilContext.Provider value={cdata}>
      <Header
        baslik={resto.FIRMA}
        handleSearch={handleSearch}

      />

      <Testimonials

        resim1={resim1}
        resim2={resim2}
        resim3={resim3}
        resim4={resim4}


      />

      {categorydata ?
        <CategoryList
          id={id}
          categorydata={categorydata}
          setProducts={setProducts}
        />
        : ""}
      {(serach.length > 0) ?
        <Portfolio
          id={id}
          title={(lang === "en") ? "Searched Products" : "Aratılan Ürünler"}
          data={(serach.length > 0) ? serach : ""}
        />
        :
        <Portfolio
          id={id}
          title={(categorydata.length > 0) ? ((lang === "en") ? categorydata[categoryorder].CATEGORY_ING : categorydata[categoryorder].CATEGORY) : ""}
          data={((productsData.length > 0) & (categorydata.length > 0)) ? filterItem() : ""}
        />


      }


      <Footer
        data={resto}
      />
    </DilContext.Provider>



  )
}

export default Home
